import React from "react";

const LeaveOptions = ({ option, halfType, onChange }) => {
  return (
    <div className="form-row">
      <div className="form-group">
        <label>Options:</label>

        <div>
          <label>
            <input
              type="radio"
              name="leaveOption"
              value="FullDay"
              checked={option === "FullDay"}
              onChange={() => onChange("option", "FullDay")}
            />
            Whole Day
          </label>
        </div>

        <div>
          <label>
            <input
              type="radio"
              name="leaveOption"
              value="HalfDay"
              checked={option === "HalfDay"}
              onChange={() => onChange("option", "HalfDay")}
            />
            Half Day
          </label>
        </div>

        {option === "HalfDay" && (
          <div style={{ marginLeft: "20px", marginTop: "10px" }}>
            <label>
              <input
                type="radio"
                name="halfType"
                value="FirstHalf"
                checked={halfType === "FirstHalf"}
                onChange={() => onChange("halfType", "FirstHalf")}
              />
              First Half of the day
            </label>
            <br />
            <label>
              <input
                type="radio"
                name="halfType"
                value="SecondHalf"
                checked={halfType === "SecondHalf"}
                onChange={() => onChange("halfType", "SecondHalf")}
              />
              Second Half of the day
            </label>
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveOptions;
